import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { TeamSummaryService } from '../team-summary.service';
import { UserAddService } from './user-add.service';

import { Roles } from './../../../../model';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {

  @ViewChild('successModal') successModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  teams: any[];
  roles = Roles;

  addUserForm: FormGroup;
    email: string = "";
    firstName: string = "";
    lastName: string = "";
    teamId = "";
    role = "";

  constructor(
    private router: Router,
    private teamSummaryService: TeamSummaryService,
    private userAddService: UserAddService,
    private translateService: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    ) {
      translateService.setDefaultLang('en-us');
    }

createAddUserForm() {
        this.addUserForm = this.formBuilder.group({
            email: new FormControl('', [
                Validators.required,
                Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
                Validators.maxLength(100)
            ]),
            firstName: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)

            ]),
            lastName: new FormControl('', [
                Validators.required,
                Validators.maxLength(100)

            ]),
            teamId: new FormControl('', [
                Validators.required,
                Validators.min(1)

            ]),
            role: new FormControl('', [
                Validators.required

            ])
        });
}

addUser(addUserForm) {

        this.userAddService.create(addUserForm.controls).subscribe(
            data  => {
                if (data) {
                    this.dialog.showModal('showSucModalBtn');
                }
            },
            error => {
              this.exception.showError(error, 'showDanModalBtn');
              this.redirect = false;
            }
        );

    }

  ngOnInit() {
    this.createAddUserForm();

    this.teamSummaryService.getSummary()
      .subscribe((data: any) => {

        this.teams = data;

        this.addUserForm.setValue({
          email: '' ,
          firstName: '' ,
          lastName: '' ,
          teamId: 0 ,
          role: ''
         });

      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });
  }

    closeSuccessModel() {
    this.router.navigate(['/home/users']);
  }

  continue() {
    this.successModal.hide();
    this.router.navigate([this.router.url]);
    this.ngOnInit();
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/users']);
    }
    else {
      this.dangerModal.hide();
    }

  }



}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/user/user-add/user-add.component.ts